export class Controller {

    /** @ngInject */
    constructor($uibModal, Alert) {
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    $onInit() {
    }

    showRegenerateModal() {
        this.$uibModal
            .open({
                component: 'companyManageApplicationIntegrationDevelopersAppKeyPasswordRegenerate',
                resolve: {
                    companyId: () => this.companyId,
                    appId: () => this.application.id,
                },
            }).result
            .then((value) => this.application.applicationApiPassword = value)
            .then(() => this.Alert('success', 'company.manage-application.integration-developers.app-key-password.regenerate.regenerated'))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/app-key-password/app-key-password.controller.js